import { TAssetsOrderTab } from '@webtrader/core/constants/order';
import request from '@webtrader/core/request';

export enum EOrderTableColumn {
  VOLUME = 'VOLUME',
  UNITS = 'UNITS',
  ENTRY_PRICE = 'ENTRY_PRICE',
  CURRENT_PRICE = 'CURRENT_PRICE',
  TAKE_PROFIT = 'TAKE_PROFIT',
  STOP_LOSS = 'STOP_LOSS',
  SWAP = 'SWAP',
  FILL_POLICY = 'FILL_POLICY',
  EXPIRY = 'EXPIRY',
  EXPIRY_DATE = 'EXPIRY_DATE',
  PENDING_PRICE = 'PENDING_PRICE',
  CLOSE_PRICE = 'CLOSE_PRICE',
  COMMISSION = 'COMMISSION',
  REMARKS = 'REMARKS',
  STATE = 'STATE',
  SIZE = 'SIZE',
  // Centroid
  AVG_FILLED_PRICE = 'AVG_FILLED_PRICE',
  PRICE = 'PRICE',
  FILL_VOLUME = 'FILL_VOLUME',
  VALIDITY = 'VALIDITY',
  DEVIATION = 'DEVIATION',
  NOTIONAL = 'NOTIONAL',
  CURRENCY = 'CURRENCY',
  CENTROID_OPEN_ORDER = 'CENTROID_OPEN_ORDER',
  CENTROID_CLOSE_ORDER = 'CENTROID_CLOSE_ORDER',
  CLOSE_DATE = 'CLOSE_DATE'
}

interface IOrderColumnPreferenceParams {
  orderType: TAssetsOrderTab;
  hiddenColumnList: EOrderTableColumn[];
}

export interface IOrderColumnPreference {
  orderType: TAssetsOrderTab;
  hiddenColumnList: EOrderTableColumn[];
}

export default {
  getAll: (signal?: AbortSignal) =>
    request.get<IOrderColumnPreference[]>('/api/user/v1/order/hide/preference', { signal }),
  hide: (params: IOrderColumnPreferenceParams) => {
    return request.patch<boolean>('/api/user/v1/order/hide/preference', params);
  }
};
